require('./openYoungCardRejectChoresView.scss');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

//@ utilities
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;
const { getFormattedString, formatCurrency } = require('utilities/currencyHelper');

// @components
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const { RejectChoreStep1 } = require('components/cards/cardOpenYoung/cardOpenYoungRejectChoreSteps/rejectChoreStep1');
const { RejectChoreStep2 } = require('components/cards/cardOpenYoung/cardOpenYoungRejectChoreSteps/rejectChoreStep2');
const WizardError = require('components/commons/wizardError/wizardError')
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @actions
const openYoungCardRejectChoreActions = require('actions/openYoungCardRejectChore');
const openYoungCardChoreStatusUpdate = require('actions/openYoungCardChoreStatusUpdate');
const openYoungCardChores = require('actions/openYoungCardChores');

// @constants
const { FIRST_STEP, OPENYOUNG_CHORE_REJECTED, EURO_TEXT } = require('constants/index');

class OpenYoungCardRejectChoresView extends React.Component {
    constructor(props) {
        super(props);
        this.buildWizard = this.buildWizard.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount() {
        this.props.stateReset();
    }

    componentDidMount() {
        const { match: { params: { choreAssignmentId } }, getChoreDetail } = this.props;
        getChoreDetail(choreAssignmentId);
    }

    componentWillUnmount() {
        this.props.openYoungChoreResetStatusUpdateInfo();
    }

    buildErrorWizard(immCard) {
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cardBlock-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardError
                    errorMessage={formatText('openYoungRejectChores-errorTitle')}
                    mainButton={mainButton}
                >
                    <div className="openyoung-card-reject-chores-view__error-body">
                        <div className="col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} />
                        </div>
                        <p className="openyoung-card-reject-chores-view__error-sub-message col-md-7">
                            <FormattedText
                                value="openYoungRejectChores-errorBodyText"
                            />
                        </p>
                    </div>
                </WizardError>
            </div>
        );
    }

    buildSuccessWizard(immCard) {
        const { openYoungCardChores } = this.props;
        const choreDetail = openYoungCardChores.get('choreDetail');
        const amountReward = choreDetail.get('reward');
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cardBlock-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        const amount = getFormattedString({
            amount: amountReward,
            currency: formatCurrency(EURO_TEXT)
        });
        const taskType = formatText(`openYoungCardChores-task${choreDetail.getIn(['chore','choreId'])}`)
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardSuccess
                    successMessage={formatText('openYoungRejectChores-successTitle')}
                    mainButton={mainButton}
                >
                    <div className="openyoung-card-reject-chores-view__success-body">
                        <div className="col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} />
                        </div>
                        <div className="col-md-7">
                            <p className="openyoung-card-reject-chores-view__success-sub-message">
                                <FormattedText
                                    value="openYoungRejectChores-successBodyText"
                                />
                            </p>
                            <p className="openyoung-card-reject-chores-view__rejected-amount">
                                <FormattedText
                                    value="openYoungRejectChores-chore"
                                />
                            </p>
                            <p className="openyoung-card-reject-chores-view__value">
                                {taskType}
                            </p>
                            <p className="openyoung-card-reject-chores-view__rejected-amount">
                                <FormattedText
                                    value="openYoungRejectChores-amount"
                                />
                            </p>
                            <p className="openyoung-card-reject-chores-view__value">
                                {amount}
                            </p>
                        </div>
                    </div>
                </WizardSuccess>
            </div>
        );
    }

    handleCancel() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/chores`);
    }

    handleFinish() {
        const {
            immOpenYoungCardRejectChore,
            openYoungCardChores,
            match: { params: { choreAssignmentId } },
            updateChoreStatus
        } = this.props;
        const step =  immOpenYoungCardRejectChore.get('steps').get(0);
        const choreDetail = openYoungCardChores.get('choreDetail');
        const choreStatusDetails = {
            choreAssignmentId: choreAssignmentId,
            confirmationComment: step.get('remark'),
            choreStatusId: OPENYOUNG_CHORE_REJECTED,
            reward: choreDetail.get('reward',0)
        }
        updateChoreStatus(choreStatusDetails);
    }

    buildWizard( immCard ) {
        const {
            immOpenYoungCardRejectChore,
            openYoungCardChores,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;

        const immSteps = immOpenYoungCardRejectChore.get('steps');
        const choreDetail = openYoungCardChores.get('choreDetail');
        const formattedChildName = immCard.get('beneficiaryNameOnCard').replace(/\*/g, ' ');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immOpenYoungCardRejectChore.get('visibleStep')}
                showPreLeaveModal={true}>
                <WizardStep
                    position="first"
                    cancelButton={true}
                >
                    <RejectChoreStep1
                        immStep={immSteps.get(FIRST_STEP)}
                        choreDetail={choreDetail}
                        childName={formattedChildName}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="openYoungRejectChores-Confirm"
                    addLoadingBehaviour={false}
                >
                    <RejectChoreStep2
                        immStep={immSteps.get(FIRST_STEP)}
                        choreDetail={choreDetail}
                        childName={formattedChildName}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    render() {
        const {
            immCards,
            openYoungCardChoreStatusUpdateInfo,
            openYoungCardChores,
            match: { params: { cardId } },
        } = this.props;

        const immCard = immCards.get('byId').get(cardId);
        const type = immCard.get('type');
        const subtitleLeft = formatText(`cards-${type}`);
        const subtitleRight = immCard.get('alias').get('current');

        let bodyContent;
        if (immCards.get('isFetching')) {
            bodyContent = <LoadingSection />;
        } else if(immCard) {
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.getIn(['alias','current']),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-openYoungChores'),
                    url: `/myprofile/cards/${cardId}/chores`
                },
                {
                    text: formatText('breadcrumb-openYoungRejectChores')
                }
            ];
            let content;
            if(openYoungCardChores.get('getChoreDetailFetch')) {
                content = <LoadingSection />;
            }else if(openYoungCardChoreStatusUpdateInfo.get('submitSuccessful')) {
                content = this.buildSuccessWizard(immCard);
            }else if(openYoungCardChoreStatusUpdateInfo.get('submitError')) {
                content = this.buildErrorWizard(immCard);
            }else {
                content = (
                    <div>
                        <div className="col-md-12 col-lg-8">
                            {this.buildWizard(immCard)}
                        </div>
                        <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                    </div>
                );
            }
            bodyContent = (
                <div className="openyoung-card-reject-chores-view">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={getFinalTitle(`openYoungRejectChores-headerTitle`)}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return bodyContent;
    }
}

OpenYoungCardRejectChoresView.propTypes = {
    getChoreDetail: PropTypes.func,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object,
    immOpenYoungCardRejectChore: PropTypes.object.isRequired,
    openYoungCardChoreStatusUpdateInfo: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object,
    openYoungChoreResetStatusUpdateInfo: PropTypes.func.isRequired,
    match: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func,
    stateReset: PropTypes.func,
    updateChoreStatus: PropTypes.func,
    validateStep: PropTypes.func.isRequired
};

module.exports.Constructor = OpenYoungCardRejectChoresView;
module.exports.OpenYoungCardRejectChoresView = connect(
    state => ({
        immCards: state.cards,
        immOpenYoungCardRejectChore: state.openYoungCardRejectChore,
        openYoungCardChoreStatusUpdateInfo: state.openYoungCardChoreStatusUpdateInfo,
        openYoungCardChores: state.openYoungCardChores
    }),
    {
        getChoreDetail: openYoungCardChores.getChoreDetail,
        openYoungChoreResetStatusUpdateInfo: openYoungCardChoreStatusUpdate.openYoungChoreResetStatusUpdateInfo,
        setVisibleStep: openYoungCardRejectChoreActions.setVisibleStep,
        setWillCancel: openYoungCardRejectChoreActions.setWillCancel,
        stateReset: openYoungCardRejectChoreActions.stateReset,
        updateChoreStatus: openYoungCardChoreStatusUpdate.updateChoreStatus,
        validateStep: openYoungCardRejectChoreActions.validateStep
    })(withRouter(OpenYoungCardRejectChoresView));
